export class AboutRestaurant {
    title: string|null;
    subtitle: string|null;
    description: string|null;
    banner:string|null;
    socialMedia:{
        facebook:string;
        instagram:string;
        twitter:string;
    }|null
    hours: {
        mon: string;
        tue: string;
        wed: string;
        thu: string;
        fri: string;
        sat: string;
        sun: string;
    }|null
    additionalContent:any|null;

    constructor(title: string|null, subtitle: string|null, description: string|null, banner:string|null, 
    socialMedia:{ facebook:string; instagram:string; twitter:string; }|null,
    hours:{ mon: string; tue: string; wed: string; thu: string; fri: string; sat: string; sun: string;}|null,
    additionalContent:any|null) {
        this.title = title;
        this.subtitle = subtitle;
        this.description = description;
        this.banner = banner;
        
        this.socialMedia = socialMedia;
        this.hours = hours;
        this.additionalContent = additionalContent;
    }



    /** Converts this object into a format that can be saved on our database (DynamoDB) */
	toAWSObject(){
        let result:any = {};
        if(this.title!=null){
            result["title"] = this.title;
        }
        if(this.subtitle!=null){
            result["subtitle"] = this.subtitle;
        }
        if(this.description!=null){
            result["description"] = this.description;
        }
        if(this.socialMedia!=null){
            result["socialMedia"] = this.socialMedia;
        }
        if(this.hours!=null){
            result["hours"] = this.hours;
        }
        if(this.additionalContent!=null){
            result["additionalContent"] = this.additionalContent;
        }
			
		return result;
	}

    static newFromAws(awsAboutRestaurantItem: any): AboutRestaurant | null {
        if (awsAboutRestaurantItem != null) {
            
            let restHours = {
                mon: "---", tue: "---", wed: "---",
                thu: "---", fri: "---", sat: "---",
                sun: "---"
            } 
            if(awsAboutRestaurantItem.hours != null){
                restHours["mon"] = awsAboutRestaurantItem.hours.mon;
                restHours["tue"] = awsAboutRestaurantItem.hours.tue;
                restHours["wed"] = awsAboutRestaurantItem.hours.wed;
                restHours["thu"] = awsAboutRestaurantItem.hours.thu;
                restHours["fri"] = awsAboutRestaurantItem.hours.fri;
                restHours["sat"] = awsAboutRestaurantItem.hours.sat;
                restHours["sun"] = awsAboutRestaurantItem.hours.sun;
            }

            let socialMedia = {
                facebook:"",
                instagram:"",
                twitter:""
            }
            if(awsAboutRestaurantItem.socialMedia != null){
                socialMedia["facebook"] = awsAboutRestaurantItem.socialMedia.facebook;
                socialMedia["instagram"] = awsAboutRestaurantItem.socialMedia.instagram;
                socialMedia["twitter"] = awsAboutRestaurantItem.socialMedia.twitter;
            }
            
            return new AboutRestaurant(
                awsAboutRestaurantItem.title,
                awsAboutRestaurantItem.subtitle,
                awsAboutRestaurantItem.description,
                awsAboutRestaurantItem.banner,
                socialMedia, restHours, awsAboutRestaurantItem.additionalContent)
        } else {
            return null;
        }
    }
}